import React, { useState, useEffect } from 'react';
import './Progressbar.scss';

const Progressbar = ({ variant = 'linear', value = false, progress = 0 }) => {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    // Reset animated progress to 0 when the progress prop changes
    setAnimatedProgress(0);

    // Calculate the step size for smooth animation
    const step = progress / 50; // Adjust the divisor for faster or slower animation
    let currentProgress = 0;

    const interval = setInterval(() => {
      currentProgress += step;
      if (currentProgress >= progress) {
        setAnimatedProgress(progress);
        clearInterval(interval);
      } else {
        setAnimatedProgress(currentProgress);
      }
    }, 10); // Adjust the interval for smoother or faster animation

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [progress]);

  if (variant === 'circular') {
    return (
      <div className="progressbar-circular">
        <svg className="circular-progress" viewBox="0 0 36 36">
          <path
            className="circle-bg"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className="circle"
            strokeDasharray={`${animatedProgress}, 100`}
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        {value && <div className="progress-value">{Math.round(animatedProgress)}%</div>}
      </div>
    );
  }

  return (
    <div className="progressbar-linear-container">
      <div className="progressbar-linear">
        <div className="linear-progress" style={{ width: `${animatedProgress}%` }}></div>
      </div>
      {value && <div className="progress-label">{Math.round(animatedProgress)}%</div>}
    </div>
  );
};

export default Progressbar;